import { render, staticRenderFns } from "./CarouselBanners.vue?vue&type=template&id=d6536272&scoped=true&"
import script from "./CarouselBanners.vue?vue&type=script&lang=js&"
export * from "./CarouselBanners.vue?vue&type=script&lang=js&"
import style0 from "./CarouselBanners.vue?vue&type=style&index=0&id=d6536272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6536272",
  null
  
)

export default component.exports